
import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET } from "@angular/router";
import "rxjs/add/operator/filter";
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
import { AuthenticationService } from "@app/shared/services/authentication.service";

interface IBreadcrumb {
  label: string;
  url: string;
}

@Component({
  selector: "app-breadcrum",
  templateUrl: './breadcrum.component.html',
  styleUrls: ['./breadcrum.component.css']
})
export class BreadcrumComponent implements OnInit {

  public breadcrumbs: IBreadcrumb[];
  label: string[];
  title: string;
  breadcrumbs1: any;
  url: string;
  userRole: string;

  /**
   * @class DetailComponent
   * @constructor
   */
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private breadcrumService: BreadcrumService,
    private authenticationService: AuthenticationService,

  ) {
    this.breadcrumbs = [];
    this.userRole = this.authenticationService.getFormattedRole();
  }


  ngOnInit() {
    const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";
    this.activatedRoute = this.activatedRoute;
    this.url = this.activatedRoute.snapshot.routeConfig.path;
    if (this.url == '') {
      this.url = window.location.href;
    }
    this.label = this.url.split("/");
    if (this.label[0] == 'market-data-detailed' || this.label[0] == 'market-data-snapshot' || this.label[0] == 'research-snapshot' || this.label[0] == 'research-detail' ||
    this.label[0] == 'report-details' || this.label[0] == 'analyst-profile' || this.label[0] == 'market-data' ||
     this.label[0] == 'market-data-details' || this.label[0] == 'analyst-list') {
      if (sessionStorage.getItem('BC2Label')) {
        var breadcrumb: IBreadcrumb = {
          label: sessionStorage.getItem('BC2Label'),
          url: sessionStorage.getItem('BC2Url')
        };
        this.breadcrumbs.push(breadcrumb);

      }
      if (sessionStorage.getItem('BC3Label')) {
        var breadcrumb: IBreadcrumb = {
          label: sessionStorage.getItem('BC3Label'),
          url: sessionStorage.getItem('BC3Url')
        };
        this.breadcrumbs.push(breadcrumb);

      }

      if (sessionStorage.getItem('BC4Label')) {
        var breadcrumb: IBreadcrumb = {
          label: sessionStorage.getItem('BC4Label'),
          url: ''
        };
        this.breadcrumbs.push(breadcrumb);

      }
      if (sessionStorage.getItem('BC5Label')) {
        var breadcrumb: IBreadcrumb = {
          label: sessionStorage.getItem('BC5Label'),
          url: sessionStorage.getItem('BC5Url')
        };
        this.breadcrumbs.push(breadcrumb);

      }
    }
    else if(this.label[0] == "research" && this.label[1] == "all-research"){
            var breadcrumb: IBreadcrumb = {
              label: 'All Market Data',
              url: ''
            };
            this.breadcrumbs.push(breadcrumb);
            this.breadcrumService.setUrl('BC2Url', this.userRole + '/' + this.label[0]);
          }    
    else {
      var final = this.label[this.label.length - 1].split("-");
      if (final[2]) {
        var finalData = final[0] + ' ' + final[1] + ' ' + final[2];
      }
      else if (!final[2] && final[1]) {
        var finalData = final[0] + ' ' + final[1];
      }
      else {
        var finalData = final[0];

      }
      if (finalData == 'upcoming' || finalData == 'editor') {
        var breadcrumb: IBreadcrumb = {
          label: 'Reports',
          // params: child.snapshot.params,
          url: 'tech-analyst/reports'
        };
        this.breadcrumbs.push(breadcrumb);

      }
      this.breadcrumService.setUrl('BC2Label', finalData);
      if (this.label[0] === 'reports') {
        this.breadcrumService.setUrl('BC2Url', this.url);
      }
      if (this.label[0] === 'subscription') {
        finalData = this.label[0];
        this.breadcrumService.setUrl('BC2Label', this.label[0]);
        this.breadcrumService.setUrl('BC2Url', this.userRole + '/' + this.label[0]);
      }
      else {
        if(this.url ==='about-us'){
          this.breadcrumService.setUrl('BC2Url', this.url);
        } 
        else if(this.url ==='our-services'){
          this.breadcrumService.setUrl('BC2Url', this.url);
        }
        else if(this.url === 'individual-market-data') {
          this.breadcrumService.setUrl('BC2Url', this.url);

        }
        else{
          this.breadcrumService.setUrl('BC2Url', this.userRole + '/' + this.url);
        }

      }
      var breadcrumb: IBreadcrumb = {
        label: finalData,
        // params: child.snapshot.params,
        url: ''
      };
      this.breadcrumbs.push(breadcrumb);

    }

    // for future reference

    // if (this.label[0] == 'research-snapshot') {
    //   var breadcrumb: IBreadcrumb = {
    //     label: sessionStorage.getItem('switchLabel'),
    //     url: sessionStorage.getItem('switchUrl')
    //   };
    //   this.breadcrumbs.push(breadcrumb);
    //   var breadcrumb: IBreadcrumb = {
    //     label: sessionStorage.getItem('researchTitle'),
    //     url: ''
    //   };
    //   this.breadcrumbs.push(breadcrumb);
    // }
    // else if (this.label[0] == 'research-detail') {
    //   var breadcrumb: IBreadcrumb = {
    //     label: sessionStorage.getItem('switchLabel'),
    //     url: sessionStorage.getItem('switchUrl')
    //   };
    //   this.breadcrumbs.push(breadcrumb);
    //   var breadcrumb: IBreadcrumb = {
    //     label: sessionStorage.getItem('researchTitle'),
    //     url: sessionStorage.getItem('researchDataUrl')
    //   };
    //   this.breadcrumbs.push(breadcrumb);
    //   var breadcrumb: IBreadcrumb = {
    //     label: 'Research Data',
    //     url: ''
    //   };
    //   this.breadcrumbs.push(breadcrumb);

    // }
    // else if (this.label[0] == 'report-details') {
    //   var breadcrumb: IBreadcrumb = {
    //     label: sessionStorage.getItem('reportPage'),
    //     url: sessionStorage.getItem('reportLink'),
    //   };
    //   this.breadcrumbs.push(breadcrumb);
    //   var breadcrumb: IBreadcrumb = {
    //     label: sessionStorage.getItem('reportTitle'),
    //     url: ''
    //   };
    //   this.breadcrumbs.push(breadcrumb);

    // }
    // else if (this.label[0] == 'analyst-profile') {
    //   if (sessionStorage.getItem('sheduleCallUrl')) {
    //     var breadcrumb: IBreadcrumb = {
    //       label:sessionStorage.getItem('sheduleCallLabel'),
    //       url: sessionStorage.getItem('sheduleCallUrl'),
    //     };
    //     this.breadcrumbs.push(breadcrumb);
    //   }

    //    if (sessionStorage.getItem('analystList')) {
    //     var breadcrumb: IBreadcrumb = {
    //       label:'Analyst List',
    //       url: sessionStorage.getItem('analystList'),
    //     };
    //     this.breadcrumbs.push(breadcrumb);
    //   }
    //   if (sessionStorage.getItem('analystName')) {
    //     var breadcrumb: IBreadcrumb = {
    //       label: sessionStorage.getItem('analystName'),
    //       url: '',
    //     };
    //     this.breadcrumbs.push(breadcrumb);
    //   }

    // }
    // else if (this.label[0] == 'market-data-details') {

    //     var breadcrumb: IBreadcrumb = {
    //       label:'All Bookmarks',
    //       url:  sessionStorage.getItem('bookmarkUrl'),
    //     };
    //     this.breadcrumbs.push(breadcrumb);



    //     var breadcrumb: IBreadcrumb = {
    //       label: sessionStorage.getItem('marketDataname'),
    //       url: '',
    //     };
    //     this.breadcrumbs.push(breadcrumb);


    // }
    // else if (this.label[0] == 'analyst-list') {
    //   if (sessionStorage.getItem('sheduleCallUrl')) {
    //     var breadcrumb: IBreadcrumb = {
    //       label: 'Schedule Call List',
    //       url: sessionStorage.getItem('sheduleCallUrl'),
    //     };
    //     this.breadcrumbs.push(breadcrumb);
    //   }
    //   var final = this.label[this.label.length - 1].split("-");
    //  if (final[2]) {
    //     var finalData = final[0] + ' ' + final[1] + ' ' + final[2];
    //   }
    //   else if (!final[2] && final[1]) {
    //     var finalData = final[0] + ' ' + final[1];
    //   }
    //   else {
    //     var finalData = final[0];

    //   }
    //   var breadcrumb: IBreadcrumb = {
    //     label: finalData,
    //     // params: child.snapshot.params,
    //     url: ''
    //   };
    //   this.breadcrumbs.push(breadcrumb);

    // }
    // else if (this.label[0] == 'analyst-profile') {
    //   var breadcrumb: IBreadcrumb = {
    //     label: sessionStorage.getItem('reportLabel'),
    //     url: sessionStorage.getItem('reportLink'),
    //   };
    //   this.breadcrumbs.push(breadcrumb);
    //   var breadcrumb: IBreadcrumb = {
    //     label: sessionStorage.getItem('reportTitle'),
    //     url: ''
    //   };
    //   this.breadcrumbs.push(breadcrumb);

    // } else {
    //   var final = this.label[this.label.length - 1].split("-");
    //    if (final[2]) {
    //     var finalData = final[0] + ' ' + final[1] + ' ' + final[2];
    //   }
    //   else if (!final[2] && final[1]) {
    //     var finalData = final[0] + ' ' + final[1];
    //   }
    //   else {
    //     var finalData = final[0];

    //   }
    //   if (finalData == 'upcoming' || finalData == 'editor') {
    //     var breadcrumb: IBreadcrumb = {
    //       label: 'Reports',
    //       // params: child.snapshot.params,
    //       url: 'tech-analyst/reports'
    //     };
    //     this.breadcrumbs.push(breadcrumb);

    //   }
    //   var breadcrumb: IBreadcrumb = {
    //     label: finalData,
    //     // params: child.snapshot.params,
    //     url: ''
    //   };
    //   this.breadcrumbs.push(breadcrumb);

    // }
  }

  goToHome(userRole) {
    this.removeSession();
    switch (userRole) {
      case 'tech-buyer':
      this.router.navigate(['/tech-buyer']);
      break;
      case 'tech-vendor':
      this.router.navigate(['/tech-vendor']);
      break;
      case 'tech-analyst':
      this.router.navigate(['/tech-analyst']);
      break;
      case 'ecosystm-staff':
      this.router.navigate(['/ecosystm-staff']);
      break;
      default:
        this.router.navigate(['/']);
        break;
    }
  }

  removeSession() {
    sessionStorage.removeItem('BC4Url');
    sessionStorage.removeItem('BC4Label');
    sessionStorage.removeItem('BC3Url');
    sessionStorage.removeItem('BC3Label');
    sessionStorage.removeItem('BC2Url');
    sessionStorage.removeItem('BC2Label');
  }

  navigateClick(url) {
    this.router.navigate([url]);
    if (url === sessionStorage.getItem('BC3Url')) {
      sessionStorage.removeItem('BC4Url');
      sessionStorage.removeItem('BC4Label');
    }
    if (url === sessionStorage.getItem('BC2Url')) {
      sessionStorage.removeItem('BC4Url');
      sessionStorage.removeItem('BC4label');
      sessionStorage.removeItem('BC3Url');
      sessionStorage.removeItem('BC3Label');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/breadcrum/breadcrum.component.ts